import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map, tap } from 'rxjs/operators';
import { Credential } from "../../autenticacao/model/credential";
import { Carteira } from "../model/carteira";
import { CarteiraUsuario } from "../model/carteira-usuario";
import { isNull } from "../utils/";
import { Lookup, LookupData } from "../model/lookup";
import { StorageProxy } from "./storage-proxy.service";
import { environment } from "../../../../environments/environment";

import { convertToQueryString } from "./query-string";
import { Conta, CriarConta, CriarContaResult, ContaConfiguracao, AtualizarContaLimites } from "../model/conta";

@Injectable()
export class ContaService {
    private api: string;

    constructor(private httpClient: HttpClient) {
        this.api = '/api/contas';
    }

    public obterLookup(filtro?: any) {
        let url = `${this.api}/lookup`;

        if (filtro)
            url += "?" + Object.keys(filtro).map(prop => `${prop}=${filtro[prop]}`).join("&");

        return this.httpClient.get<LookupData>(url).pipe(map(f => {
            let lookup = LookupData.fromRaw(f);
            return lookup;
        }));
    }

    public obterContas(filtro?: any) {
        let url = this.api;

        if (filtro) {
            const params = Object.keys(filtro)
                .filter(prop => filtro[prop] !== null && filtro[prop] !== undefined && filtro[prop] !== '')
                .map(prop => `${prop}=${encodeURIComponent(filtro[prop])}`)
                .join("&");

            if (params)
                url += "?" + params;
        }

        return this.httpClient.get<Array<Conta>>(url).pipe(
            map(data => data.map(c => Conta.fromRaw(c)))
        );
    }

    public inativarConta(contaId: string) {
        return this.httpClient.patch<void>(`${this.api}/${contaId}/inativar`, null);
    }

    public ativarConta(contaId: string) {
        return this.httpClient.patch<void>(`${this.api}/${contaId}/ativar`, null);
    }

    public criarConta(criarConta: CriarConta) {
        return this.httpClient.post<CriarContaResult>(`${this.api}/criar-conta`, criarConta);
    }

    public obterContaConfiguracao(contaId: string) {
        return this.httpClient.get<ContaConfiguracao>(`${this.api}/${contaId}`).pipe(
            map(data => ContaConfiguracao.fromRaw(data))
        );
    }

    public atualizarContaLimites(contaId: string, limites: AtualizarContaLimites) {
        return this.httpClient.put<void>(`${this.api}/${contaId}/limites`, limites);
    }

    public alterarContaLoginUsuario(hashConta: string) {
        let userData = StorageProxy.get<Credential>('userData')
        let body = Object.assign({}, { "hashConta": hashConta, "refreshToken": userData.refreshToken });

        return this.httpClient
            .post<Credential>(`${this.api}/conta-login-usuario`, body)
            .pipe(
                tap(result => {
                    StorageProxy.set('userData', Object.assign({}, userData, result));
                }),
                map(res => Object.assign({}, res, { newToken: true })));


        // this.authService
        //     .refreshToken().pipe(
        //         switchMap((credential) => {
        //             if (credential.newToken) {
        //                 this.tokenSubject.next(credential.AccessToken);
        //                 return next.handle(this.addToken(req, credential.AccessToken));
        //             }
        //             return this.logoutUser();
        //         }),
        //         catchError((_) => this.logoutUser()),
        //         finalize(() => (this.isRefreshingToken = false)))
        //     .subscribe();

    }

    /*
        public obterCarteiras(filtro?: any) {
            let url = this.api;
    
            if (filtro)
                url += "?" + Object.keys(filtro).map(prop => `${prop}=${filtro[prop]}`).join("&");
    
            return this.httpClient.get<Array<Carteira>>(url);
        }
    
        public obterPorId(id: number) {
            // return this.httpClient.get<Carteira>(`${environment.serverUrl}/api/carteiras/${id}`)
            //     .pipe(map(f => Carteira.fromRaw(f)));
    
            return this.httpClient.get<Carteira>(`${this.api}/${id}`)
                .pipe(map(f => {
                    let carteira = Carteira.fromRaw(f);
    
                    if (!isNull(carteira.carteiraUsuario))
                        carteira.carteiraUsuario = carteira.carteiraUsuario.map((m: CarteiraUsuario) => CarteiraUsuario.fromRaw(m));
    
                    return carteira;
                }));
        }
    
        public criar(carteira: Carteira) {
            return this.httpClient.post<number>(`${this.api}/`, carteira);
        }
    
        public atualizar(carteira: Carteira) {
            return this.httpClient.put<number>(`${this.api}/${carteira.carteiraId}`, carteira);
        }
    
        public desativarCarteira(carteiraId: number) {
            return this.httpClient.patch<any>(`${this.api}/${carteiraId}/desativar-carteira`, null);
        }
    
        public obterCarteiraPadrao() {
            return this.httpClient.get<any>(`${this.api}/carteira-padrao`);
        }*/
}
